'use strict';

var GridToolbarRomSummaryTopSpillDirective = function GridToolbarRomSummaryTopSpillDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-rom-summary-top-spill.html'),
    controller: 'GridToolbarRomSummaryTopSpillController'
  };
};
GridToolbarRomSummaryTopSpillDirective.$inject = [];
module.exports = GridToolbarRomSummaryTopSpillDirective;